import { I as w } from "../IdController-Cpj_A6H5.js";
import { P as y } from "../pwc-interactive-element-B6286Ky3.js";
import { x as d, c as g } from "../lit-element-8JrrHldg.js";
import { P as $ } from "../pwc-component-size.enum-ldIKEMHl.js";
import { p as o } from "../pwcProperty-CTLG9yrF.js";
import { w as v } from "../watch-ChG-_stu.js";
import { c as m } from "../clsx-DB4S2d7J.js";
import { n as _ } from "../property-4FoNj0Pi.js";
import { r as P } from "../state-D4BCZ2JK.js";
import { o as f } from "../if-defined-Cd-e8xtV.js";
import { n as C } from "../ref-ArR26hg7.js";
var R = Object.defineProperty, k = Object.getOwnPropertyDescriptor, a = (e, t, s, l) => {
  for (var r = l > 1 ? void 0 : l ? k(t, s) : t, c = e.length - 1, h; c >= 0; c--)
    (h = e[c]) && (r = (l ? h(t, s, r) : h(r)) || r);
  return l && r && R(t, s, r), r;
}, x = (e, t, s) => {
  if (!t.has(e))
    throw TypeError("Cannot " + s);
}, E = (e, t, s) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, s);
}, u = (e, t, s) => (x(e, t, "access private method"), s), n, p;
const b = "pwc-radio";
let i = class extends y {
  constructor() {
    super(...arguments), E(this, n), this.slotControlled = ["default", "description"], this._labelled = !1, this.idController = new w(this, {
      base: "PwcRadio",
      children: ["input"]
    });
  }
  get checked() {
    var e;
    return ((e = this.interactiveEl) == null ? void 0 : e.checked) ?? this._checked;
  }
  set checked(e) {
    this._checked = e, this.interactiveEl && (this.interactiveEl.checked = e);
  }
  handleLabelChange() {
    var e;
    this._labelled = !!this.label && ((e = this.label) == null ? void 0 : e.length) > 0;
  }
  handleLabelledChange() {
    this._labelled = this.labelled;
  }
  render() {
    const {
      idController: {
        id: e,
        child: { input: t }
      }
    } = this, s = () => ({
      PwcRadio: !0,
      "PwcRadio--checked": this.checked,
      "PwcRadio--disabled": this.disabled,
      "PwcRadio--error": this.error,
      "PwcRadio--readonly": this.readonly,
      "PwcRadio--sm": this.size === "sm",
      "PwcRadio--md": this.size !== "sm" && this.size !== "lg",
      "PwcRadio--lg": this.size === "lg"
    }), l = () => d`
      <input
        ${C(this.interactiveElementRef)}
        class="PwcRadio__input"
        type="radio"
        title=${this.title}
        name=${this.name}
        id=${t}
        value=${f(this.value)}
        ?checked=${this._checked}
        ?disabled=${this.disabled}
        ?readonly=${this.readonly}
        tabindex=${f(this.tabIndex)}
        ?aria-disabled=${this.disabled}
        ?aria-readonly=${this.readonly}
        aria-selected=${this._checked}
        role="radio"
        @change=${u(this, n, p)}
      />
      <span
        class="PwcRadio__control"
        @click=${() => this._labelled ? null : u(this, n, p).call(this)}
      >
        <span class="PwcRadio__control__inner"></span>
      </span>
    `;
    return this._labelled ? d`<div class=${m(s())}>
        <label id="${e}" for="${t}">
          <div class="PwcRadio__label__elements">
            <div class="PwcRadio__control__container">${l()}</div>

            <div class="PwcRadio__text__label">
              <p-slot .host=${this}></p-slot>
              ${!this.slotted.default && this.label || ""}
            </div>
          </div>
        </label>

        <div class="PwcRadio__text__description">
          <p-slot .host=${this} name="description"></p-slot>
          ${!this.slotted.description && this.description || ""}
        </div>

        ${this.error && this.errorMessages ? d`<pwc-input-message
              .errorMessages=${this.errorMessages}
            ></pwc-input-message>` : null}
      </div>` : d`
      <div id=${e} class=${m(s())}>${l()}</div>
    `;
  }
};
n = /* @__PURE__ */ new WeakSet();
p = function() {
  this.disabled || this.readonly || (this.checked = !0, this.emit("p-change", { detail: !0 }));
};
i.tagName = b;
a([
  o({ type: String, default: $.Medium })
], i.prototype, "size", 2);
a([
  o({ type: Boolean, default: !1 })
], i.prototype, "disabled", 2);
a([
  _({ type: String })
], i.prototype, "label", 2);
a([
  o({ type: Boolean, default: !1 })
], i.prototype, "labelled", 2);
a([
  _({ type: String })
], i.prototype, "description", 2);
a([
  o({ type: String, default: "" })
], i.prototype, "title", 2);
a([
  o({ type: String, default: "" })
], i.prototype, "name", 2);
a([
  _()
], i.prototype, "value", 2);
a([
  o({ type: Boolean, attribute: "checked", default: !1 })
], i.prototype, "_checked", 2);
a([
  P()
], i.prototype, "_labelled", 2);
a([
  v("label")
], i.prototype, "handleLabelChange", 1);
a([
  v("labelled")
], i.prototype, "handleLabelledChange", 1);
i = a([
  g(b)
], i);
export {
  i as PwcRadio
};
